import React, { useState, useEffect, useRef } from 'react';
import {
    Box,
    Typography,
    IconButton,
    Switch,
    Tooltip,
    Button,
    CircularProgress,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Divider,
    LinearProgress,
    Paper,
    Checkbox,
    FormControlLabel,
    FormGroup
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import GetAppIcon from '@material-ui/icons/GetApp';
import CancelIcon from '@material-ui/icons/Cancel';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import axios from 'axios';
import LocationsService from '../../services/LocationsService';
import notify from '../../utils/notifier';

import uploadIllustration from '../../icons/Icons.png';

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        borderRadius: '4px',
        fontFamily: 'Montserrat',
        width: '640px',
        maxWidth: '640px',
        '& *': {
            fontFamily: 'Montserrat !important'
        }
    },
    dialogTitle: {
        fontWeight: 700,
        fontSize: '20px',
        color: '#0F0F19',
        minHeight: '60px',
        height: '60px',
        padding: '0 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    dialogContent: {
        padding: '24px',
        background: '#F9FCFF',
        fontFamily: 'Montserrat',
        borderTop: '1px solid #E0E0E0',
        borderBottom: '1px solid #E0E0E0'
    },
    selectControl: {
        background: 'white',
        fontFamily: 'Montserrat'
    },
    formControl: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: '#FFFFFF !important',
            borderRadius: '8px !important',
            minHeight: '56px',
            '& fieldset': {
                borderColor: '#BDBDBD !important',
                borderWidth: '1.5px !important',
                borderRadius: '8px !important'
            },
            '&:hover fieldset': {
                borderColor: '#757575 !important',
                borderWidth: '1.5px !important'
            },
            '&.Mui-focused fieldset': {
                borderColor: '#006DB3 !important',
                borderWidth: '2px !important'
            }
        },
        '& .MuiInputLabel-outlined': {
            color: '#757575 !important',
            fontWeight: '400 !important',
            fontSize: '16px !important',
            transform: 'translate(14px, 16px) scale(1) !important',
            '&.MuiInputLabel-shrink': {
                transform: 'translate(14px, -9px) scale(0.75) !important',
                backgroundColor: '#FFFFFF',
                padding: '0 4px'
            }
        },
        '& .MuiInputLabel-outlined.Mui-focused': {
            color: '#006DB3 !important'
        },
        '& .MuiSelect-select': {
            padding: '16px 14px !important',
            fontSize: '16px !important',
            color: '#212121 !important',
            display: 'flex !important',
            alignItems: 'center !important'
        },
        '& .MuiSelect-icon': {
            color: '#757575 !important',
            right: '12px !important'
        }
    },
    dropdownMenu: {
        '& .MuiPaper-root': {
            maxHeight: '168px',
            fontFamily: 'Montserrat !important',
            marginTop: '4px',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
        },
        '& .MuiMenuItem-root': {
            fontFamily: 'Montserrat !important',
            fontSize: '16px',
            color: '#212121',
            padding: '12px 16px',
            minHeight: '48px'
        }
    },
    noteText: {
        color: '#4F5B67',
        fontFamily: 'Montserrat',
        fontSize: '14px',
        '&:first-child': {
            marginTop: '16px'
        },
        '&:not(:first-child)': {
            marginTop: '4px'
        }
    },
    downloadButton: {
        marginTop: 16,
        fontWeight: 700,
        textTransform: 'none',
        color: '#00445D',
        borderColor: '#006DB3',
        borderRadius: '30px',
        padding: '10px 18px',
        background: 'white',
        fontFamily: 'Montserrat'
    },
    uploadContainer: {
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '12px',
        marginTop: '24px',
        border: '1px solid #E0E6F0'
    },
    dragDropArea: {
        borderRadius: '4px',
        backgroundColor: '#FFFFFF',
        padding: '15px 13px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease, border-color 0.2s ease',
        border: '2px dashed #B6BCC6'
    },
    dragDropAreaDragging: {
        borderColor: '#005B96'
    },
    iconContainer: {
        borderRadius: '12px',
        padding: '9px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    uploadIcon: {
        width: '38px',
        height: '38px',
        objectFit: 'contain'
    },
    dragDropText: {
        fontFamily: 'Montserrat',
        fontWeight: 500,
        fontStyle: 'normal',
        fontSize: '14px',
        lineHeight: '24px',
        letterSpacing: 0,
        color: '#0A2835'
    },
    dragDropSubtext: {
        fontFamily: 'Montserrat',
        fontWeight: 500,
        fontStyle: 'normal',
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: 0,
        color: '#52616B',
        marginTop: '4px'
    },
    uploadButton: {
        fontWeight: 600,
        textTransform: 'none',
        padding: '10px 28px',
        borderRadius: '36px',
        borderWidth: '1.8px',
        color: '#00445D',
        borderColor: '#00445D',
        fontFamily: 'Montserrat'
    },
    namespaceText: {
        display: 'block',
        marginTop: '16px'
    },
    emergencyContainer: {
        border: '1px solid #E0E6F0',
        borderRadius: '20px',
        backgroundColor: '#FFFFFF',
        boxShadow: '0 2px 6px rgba(10, 40, 53, 0.04)',
        marginTop: theme.spacing(3),
        padding: '16px 20px'
    },
    emergencyText: {
        fontWeight: 600,
        color: '#0A2835'
    },
    emergencyIcon: {
        color: '#4F5B67'
    },
    dialogActions: {
        padding: '12px 24px',
        minHeight: '60px',
        height: '60px',
        justifyContent: 'flex-end'
    },
    cancelButton: {
        fontWeight: 600,
        textTransform: 'none',
        marginRight: '12px',
        fontFamily: 'Montserrat'
    },
    submitButton: {
        fontWeight: 600,
        textTransform: 'none',
        minWidth: '90px',
        height: '36px',
        borderRadius: '100px',
        padding: '10px 16px',
        gap: '8px',
        fontSize: '14px',
        lineHeight: '16px',
        backgroundColor: '#00445D',
        color: '#FFFFFF',
        fontFamily: 'Montserrat',
        '&:hover': {
            backgroundColor: '#00445D'
        },
        '&.Mui-disabled': {
            backgroundColor: '#B6B6B9',
            color: '#FFFFFF'
        }
    },
    flexContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '2px'
    },
    emergencyFlexContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    uploadProgressContainer: {
        marginTop: '24px'
    },
    uploadProgressCard: {
        display: 'flex',
        alignItems: 'center',
        padding: '16px',
        backgroundColor: '#FFFFFF',
        borderRadius: '8px',
        gap: '16px',
        border: '1px solid #E0E0E0'
    },
    fileIconContainer: {
        position: 'relative',
        width: '48px',
        height: '48px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    fileIcon: {
        width: '40px',
        height: '40px',
        color: '#757575'
    },
    fileTypeBadge: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        backgroundColor: '#0080AF',
        color: 'white',
        fontSize: '10px',
        fontWeight: 600,
        padding: '2px 6px',
        borderRadius: '4px',
        textTransform: 'uppercase'
    },
    fileInfoContainer: {
        flex: 1,
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: '12px'
    },
    fileInfoHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
    },
    fileNameSizeContainer: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1
    },
    fileName: {
        fontFamily: 'Montserrat',
        fontWeight: 500,
        fontSize: '14px',
        color: '#0A2835',
        marginBottom: '4px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    fileSize: {
        fontFamily: 'Montserrat',
        fontSize: '12px',
        color: '#757575',
        marginTop: '4px'
    },
    progressBar: {
        height: '4px',
        borderRadius: '2px',
        backgroundColor: '#E0E0E0',
        width: '100%',
        '& .MuiLinearProgress-bar': {
            background: 'linear-gradient(to right, #0080AF, #00445D)'
        }
    },
    uploadingIcon: {
        width: '20px',
        height: '20px',
        color: '#757575'
    },
    uploadStatusContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    checkboxContainer: {
        marginTop: '24px',
        backgroundColor: '#FFFFFF',
        borderRadius: '16px',
        border: '1px solid #E0E6F0',
        padding: '18px 20px',
        boxShadow: '0 2px 6px rgba(10, 40, 53, 0.04)'
    },
    checkboxTitle: {
        fontFamily: 'Montserrat',
        fontWeight: 600,
        fontSize: '14px',
        color: '#0A2835',
        marginBottom: '12px'
    },
    checkboxLabel: {
        marginBottom: '6px',
        '& .MuiTypography-root': {
            fontFamily: 'Montserrat',
            fontWeight: 500,
            fontSize: '14px',
            color: '#0A2835'
        },
        '& .MuiCheckbox-root': {
            color: '#BDBDBD'
        },
        '& .MuiCheckbox-colorPrimary.Mui-checked': {
            color: '#00445D'
        }
    },
    uploadStatusText: {
        fontFamily: 'Montserrat',
        fontWeight: 500,
        fontSize: '14px',
        color: '#0A2835'
    },
    cancelButtonIcon: {
        cursor: 'pointer',
        padding: '0',
        '&:hover': {
            backgroundColor: 'transparent'
        }
    },
    cancelIcon: {
        fontSize: '24px',
        color: '#212121'
    },
    completedIcon: {
        fontSize: '20px',
        color: '#212121'
    },
    closeButtonIcon: {
        cursor: 'pointer',
        padding: '0',
        '&:hover': {
            backgroundColor: 'transparent'
        }
    }
}));

const UPLOAD_TYPE_CONFIG = {
    location: {
        label: 'Locations',
        templateUrl: '/templates/location_template.xlsx',
        note: [
            'Download the Excel template for reference & add locations before uploading.',
        ],
        supportsEmergency: true,
        requiresNamespace: true
    },
    city: {
        label: 'Cities',
        templateUrl: '/templates/city_template.xlsx',
        note: [
            'Download the Excel template for reference & add cities before uploading.',
        ],
        supportsEmergency: false,
        requiresNamespace: false
    },
    state: {
        label: 'States',
        templateUrl: '/templates/state_template.xlsx',
        note: [
            'Download the Excel template for reference & add states before uploading.',
        ],
        supportsEmergency: false,
        requiresNamespace: false
    },
    unlocode: {
        label: 'Unlocodes',
        templateUrl: '/templates/unlocode_template.xlsx',
        note: [
            'Download the Excel template for reference & add unlocodes before uploading.',
        ],
        supportsEmergency: false,
        requiresNamespace: false
    }
};

const LOCATION_VALIDATION_DEFAULTS = {
    checkWithNamesMatch: true,
    checkWithGeocodeMatch: false,
    skipLocodeValidation: false,
    isCreateStaticData: false
};

const BulkUploadPanel = ({
    open,
    onClose,
    onUploadSuccess,
    uploadType = 'location',
    onUploadTypeChange,
    initialNamespace = '',
    initialLocationOptions = LOCATION_VALIDATION_DEFAULTS
}) => {
    const classes = useStyles();
    const [type, setType] = useState(uploadType);
    const typeConfig = UPLOAD_TYPE_CONFIG[type] || UPLOAD_TYPE_CONFIG.location;
    const [isEmergencyUpload, setIsEmergencyUpload] = useState(false);
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [applicationNamespace, setApplicationNamespace] = useState('');
    const [isDragging, setIsDragging] = useState(false);
    const [applicationNamespaces, setApplicationNamespaces] = useState([]);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    const [isCompleted, setIsCompleted] = useState(false);
    const [checkWithNamesMatch, setCheckWithNamesMatch] = useState(false);
    const [checkWithGeocodeMatch, setCheckWithGeocodeMatch] = useState(false);
    const [skipLocodeValidation, setSkipLocodeValidation] = useState(false);
    const [createStaticData, setCreateStaticData] = useState(false);
    const cancelTokenSourceRef = useRef(null);
    const fileInputRef = useRef(null);
    const progressIntervalRef = useRef(null);

    useEffect(() => {
        if (open) {
            setType(uploadType);
        }
    }, [open, uploadType]);

    useEffect(() => {
        if (open && type === 'location') {
            const mergedOptions = {
                ...LOCATION_VALIDATION_DEFAULTS,
                ...(initialLocationOptions || {})
            };
            setCheckWithNamesMatch(mergedOptions.checkWithNamesMatch);
            setCheckWithGeocodeMatch(mergedOptions.checkWithGeocodeMatch);
            setSkipLocodeValidation(mergedOptions.skipLocodeValidation);
            setCreateStaticData(mergedOptions.isCreateStaticData);
        } else if (open) {
            setCheckWithNamesMatch(false);
            setCheckWithGeocodeMatch(false);
            setSkipLocodeValidation(false);
            setCreateStaticData(false);
        }
    }, [open, type, initialLocationOptions]);

    useEffect(() => {
        if (open) {
            if (typeConfig.requiresNamespace) {
                const namespaces = (JSON.parse(localStorage.getItem('_applicationNamespaces') || '[]') || [])
                    .filter(namespace => namespace && namespace.toLowerCase() !== 'default');
                setApplicationNamespaces(namespaces);
                if (initialNamespace && namespaces.includes(initialNamespace)) {
                    setApplicationNamespace(initialNamespace);
                } else {
                    setApplicationNamespace(namespaces.length > 0 ? namespaces[0] : '');
                }
            } else {
                setApplicationNamespaces([]);
                setApplicationNamespace('');
            }
        } else {
            resetForm();
        }
    }, [open, typeConfig.requiresNamespace, initialNamespace]);

    const resetForm = () => {
        setIsEmergencyUpload(false);
        setFile(null);
        setLoading(false);
        setIsDragging(false);
        setUploadProgress(0);
        setIsUploading(false);
        setIsCompleted(false);
        setCheckWithNamesMatch(false);
        setCheckWithGeocodeMatch(false);
        setSkipLocodeValidation(false);
        setCreateStaticData(false);
        if (progressIntervalRef.current) {
            clearInterval(progressIntervalRef.current);
            progressIntervalRef.current = null;
        }
        if (cancelTokenSourceRef.current) {
            cancelTokenSourceRef.current.cancel('Upload cancelled by user');
            cancelTokenSourceRef.current = null;
        }
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };

    const formatFileSize = (bytes) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    };

    const getFileExtension = (fileName) => {
        if (!fileName) return '';
        const parts = fileName.split('.');
        return parts.length > 1 ? parts[parts.length - 1].toUpperCase() : '';
    };

    const handleMarkEmergencyChange = (event) => {
        setIsEmergencyUpload(event.target.checked);
    };

    const simulateUploadProgress = () => {
        // Clear any existing interval
        if (progressIntervalRef.current) {
            clearInterval(progressIntervalRef.current);
        }

        setIsUploading(true);
        setUploadProgress(0);

        // Simulate progress
        progressIntervalRef.current = setInterval(() => {
            setUploadProgress(prev => {
                if (prev >= 90) {
                    if (progressIntervalRef.current) {
                        clearInterval(progressIntervalRef.current);
                        progressIntervalRef.current = null;
                    }
                    return prev;
                }
                return prev + Math.random() * 15;
            });
        }, 200);

        // Complete the simulation after a delay
        setTimeout(() => {
            if (progressIntervalRef.current) {
                clearInterval(progressIntervalRef.current);
                progressIntervalRef.current = null;
            }
            setUploadProgress(100);
            setTimeout(() => {
                setIsUploading(false);
                setIsCompleted(true);
            }, 500);
        }, 2000);
    };

    const handleFileSelection = (event) => {
        const selectedFile = event.target.files && event.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            // Automatically start simulated upload
            simulateUploadProgress();
        }
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (event) => {
        event.preventDefault();
        setIsDragging(false);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        setIsDragging(false);
        const droppedFile = event.dataTransfer.files && event.dataTransfer.files[0];
        if (droppedFile) {
            setFile(droppedFile);
            // Automatically start simulated upload
            simulateUploadProgress();
        }
    };

    const handleBrowseClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleRemoveCompletedFile = () => {
        resetForm();
    };

    const handleDownloadTemplate = () => {
        if (typeConfig.templateUrl) {
            window.open(typeConfig.templateUrl, '_blank');
        }
    };

    const handleCancel = () => {
        resetForm();
        onClose();
    };

    const handleCancelUpload = () => {
        if (progressIntervalRef.current) {
            clearInterval(progressIntervalRef.current);
            progressIntervalRef.current = null;
        }
        setIsUploading(false);
        setIsCompleted(false);
        setUploadProgress(0);
        setFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
        notify({ type: 'info', message: 'Upload cancelled' });
    };

    const handleSubmit = async () => {
        if (!file) {
            notify({ type: 'error', message: 'Please select a file to upload.' });
            return;
        }

        if (typeConfig.requiresNamespace && !applicationNamespace) {
            notify({ type: 'error', message: 'No default application namespace configured.' });
            return;
        }

        // Only proceed if upload is completed (simulated)
        if (!isCompleted) {
            return;
        }

        // Create cancel token
        cancelTokenSourceRef.current = axios.CancelToken.source();
        setLoading(true);

        try {
            const userDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
            const userEmail = userDetails.emailAddress || '';

            // Map UI type to API entityType
            const entityTypeMap = {
                'location': 'locations',
                'city': 'cities',
                'state': 'states',
                'unlocode': 'unlocodes'
            };

            const entityType = entityTypeMap[type] || 'locations';
            const priority = typeConfig.supportsEmergency && isEmergencyUpload ? 'EMERGENCY' : 'NORMAL';
            const locationValidationOptions = type === 'location'
                ? {
                    checkWithNamesMatch,
                    checkWithGeocodeMatch,
                    skipLocodeValidation,
                    isCreateStaticData: createStaticData
                }
                : undefined;

            await LocationsService.bulkUploadEntityV3(
                entityType,
                file,
                applicationNamespace,
                userEmail,
                priority,
                locationValidationOptions
            );

            notify({ type: 'success', message: 'Upload request submitted successfully.' });
            if (typeof onUploadSuccess === 'function') {
                onUploadSuccess();
            }
            resetForm();
            onClose();
        } catch (error) {
            if (axios.isCancel(error)) {
                setLoading(false);
                return;
            }
            console.error('Upload error:', error);
            notify({ type: 'error', message: error.message || 'Upload failed. Please try again.' });
        } finally {
            setLoading(false);
        }
    };

    const handleTypeChange = (event) => {
        const newType = event.target.value;
        setType(newType);
        if (typeof onUploadTypeChange === 'function') {
            onUploadTypeChange(newType);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleCancel}
            maxWidth="md"
            fullWidth
            PaperProps={{
                className: classes.dialogPaper
            }}
        >
            <DialogTitle disableTypography className={classes.dialogTitle}>
                <Typography variant="h6" style={{ fontWeight: 700, fontSize: '20px', margin: 0, lineHeight: 'normal' }}>
                    Bulk Upload
                </Typography>
                <IconButton onClick={handleCancel} size="small" style={{ padding: '4px' }}>
                    <CloseIcon style={{ fontSize: '20px' }} />
                </IconButton>
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <FormControl variant="outlined" fullWidth className={classes.formControl}>
                    <InputLabel id="bulk-upload-type-select-label">File Type</InputLabel>
                    <Select
                        labelId="bulk-upload-type-select-label"
                        label="File Type"
                        value={type}
                        onChange={handleTypeChange}
                        MenuProps={{
                            className: classes.dropdownMenu,
                            PaperProps: {
                                style: {
                                    maxHeight: 168,
                                    fontFamily: 'Montserrat'
                                }
                            },
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left'
                            },
                            transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left'
                            },
                            getContentAnchorEl: null
                        }}
                    >
                        {Object.entries(UPLOAD_TYPE_CONFIG).map(([value, config]) => (
                            <MenuItem key={value} value={value}>
                                {config.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {Array.isArray(typeConfig.note) && typeConfig.note.length > 0 && (
                    <Box marginTop={2}>
                        {typeConfig.note.map((line, index) => (
                            <Typography
                                key={index}
                                variant="body2"
                                className={classes.noteText}
                            >
                                {index === 0 ? `Note : ${line}` : line}
                            </Typography>
                        ))}
                    </Box>
                )}

                <Button
                    variant="outlined"
                    onClick={handleDownloadTemplate}
                    startIcon={<GetAppIcon />}
                    className={classes.downloadButton}
                >
                    Download Bulk {typeConfig.label} Template
                </Button>

                {type === 'location' && (
                    <Box className={classes.checkboxContainer}>
                        <Typography className={classes.checkboxTitle}>
                            Validation preferences
                        </Typography>
                        <FormGroup>
                            <FormControlLabel
                                className={classes.checkboxLabel}
                                control={
                                    <Checkbox
                                        checked={checkWithNamesMatch}
                                        onChange={(e) => setCheckWithNamesMatch(e.target.checked)}
                                        style={{ color: checkWithNamesMatch ? '#00445D' : '#BDBDBD' }}
                                    />
                                }
                                label="Check with names match"
                            />
                            <FormControlLabel
                                className={classes.checkboxLabel}
                                control={
                                    <Checkbox
                                        checked={checkWithGeocodeMatch}
                                        onChange={(e) => setCheckWithGeocodeMatch(e.target.checked)}
                                        style={{ color: checkWithGeocodeMatch ? '#00445D' : '#BDBDBD' }}
                                    />
                                }
                                label="Check with geocode match"
                            />
                            {/* <FormControlLabel
                                className={classes.checkboxLabel}
                                control={
                                    <Checkbox
                                        color="primary"
                                        checked={skipLocodeValidation}
                                        onChange={(e) => setSkipLocodeValidation(e.target.checked)}
                                    />
                                }
                                label="Skip locode validation"
                            />
                            <FormControlLabel
                                className={classes.checkboxLabel}
                                control={
                                    <Checkbox
                                        color="primary"
                                        checked={createStaticData}
                                        onChange={(e) => setCreateStaticData(e.target.checked)}
                                    />
                                }
                                label="Create static data"
                            /> */}
                        </FormGroup>
                    </Box>
                )}

                {!isUploading && !isCompleted && (
                    <Box className={classes.uploadContainer}>
                        <Box
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                            onClick={handleBrowseClick}
                            className={`${classes.dragDropArea} ${isDragging ? classes.dragDropAreaDragging : ''}`}
                        >
                            <Box className={classes.flexContainer}>
                                <Box className={classes.iconContainer}>
                                    <img
                                        src={uploadIllustration}
                                        alt="Upload icon"
                                        className={classes.uploadIcon}
                                    />
                                </Box>
                                <Box textAlign="left">
                                    <Typography className={classes.dragDropText}>
                                        Drag and drop files here
                                    </Typography>
                                    <Typography className={classes.dragDropSubtext}>
                                        Only .csv & .xls files of up to 5MB accepted.
                                    </Typography>
                                    {file && (
                                        <Typography variant="caption" color="textSecondary" style={{ marginTop: '6px', display: 'block' }}>
                                            Selected file: <b>{file.name}</b>
                                        </Typography>
                                    )}
                                </Box>
                            </Box>
                            <Button
                                variant="outlined"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleBrowseClick();
                                }}
                                className={classes.uploadButton}
                                disabled={loading}
                            >
                                Upload
                            </Button>
                        </Box>
                    </Box>
                )}

                {(isUploading || isCompleted) && file && (
                    <Box className={classes.uploadProgressContainer}>
                        <Paper className={classes.uploadProgressCard} elevation={0}>
                            <Box className={classes.fileIconContainer}>
                                <InsertDriveFileIcon className={classes.fileIcon} />
                                <Box className={classes.fileTypeBadge}>
                                    {getFileExtension(file.name)}
                                </Box>
                            </Box>
                            <Box className={classes.fileInfoContainer}>
                                <Box className={classes.fileInfoHeader}>
                                    <Box className={classes.fileNameSizeContainer}>
                                        <Typography className={classes.fileName}>
                                            {file.name}
                                        </Typography>
                                        <Typography className={classes.fileSize}>
                                            {formatFileSize(file.size)}
                                        </Typography>
                                    </Box>
                                    <Box className={classes.uploadStatusContainer}>
                                        {isCompleted ? (
                                            <>
                                                <CheckCircleOutlineIcon className={classes.completedIcon} />
                                                <Typography className={classes.uploadStatusText}>
                                                    Completed
                                                </Typography>
                                                <IconButton
                                                    size="small"
                                                    onClick={handleRemoveCompletedFile}
                                                    className={classes.closeButtonIcon}
                                                >
                                                    <CloseIcon className={classes.cancelIcon} />
                                                </IconButton>
                                            </>
                                        ) : (
                                            <>
                                                <CircularProgress size={20} className={classes.uploadingIcon} />
                                                <Typography className={classes.uploadStatusText}>
                                                    Uploading
                                                </Typography>
                                                <IconButton
                                                    size="small"
                                                    onClick={handleCancelUpload}
                                                    className={classes.cancelButtonIcon}
                                                >
                                                    <CancelIcon className={classes.cancelIcon} />
                                                </IconButton>
                                            </>
                                        )}
                                    </Box>
                                </Box>
                                <LinearProgress
                                    variant="determinate"
                                    value={isCompleted ? 100 : uploadProgress}
                                    className={classes.progressBar}
                                />
                            </Box>
                        </Paper>
                    </Box>
                )}

                <input
                    ref={fileInputRef}
                    type="file"
                    accept=".csv,.xls,.xlsx"
                    style={{ display: 'none' }}
                    onChange={handleFileSelection}
                />

                {/* {typeConfig.supportsEmergency && (
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        className={classes.emergencyContainer}
                    >
                        <Box className={classes.emergencyFlexContainer}>
                            <Typography variant="body1" className={classes.emergencyText}>
                                Mark as 'Emergency' Upload
                            </Typography>
                            <Tooltip title="For emergency uploads, locations will be available immediately and auto-deleted within 90 days unless approved.">
                                <InfoOutlinedIcon fontSize="small" className={classes.emergencyIcon} />
                            </Tooltip>
                        </Box>
                        <Switch
                            checked={isEmergencyUpload}
                            onChange={handleMarkEmergencyChange}
                            color="primary"
                            inputProps={{ 'aria-label': 'Mark as emergency upload' }}
                        />
                    </Box>
                )} */}
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    disabled={
                        !isCompleted || loading || (typeConfig.requiresNamespace && !applicationNamespace)
                    }
                    className={classes.submitButton}
                    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                >
                    {loading ? 'Uploading...' : 'Upload'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default BulkUploadPanel;

